const formatSendParams = (params) => {
	const validEntries = Object.entries(params).filter(
		([_, value]) => value !== null && value !== undefined && value !== ''
	)
	return new URLSearchParams(validEntries).toString()
}

export default formatSendParams
